import { useState, useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { SpeedResultState } from 'src/Common/SpeedResultState'
import { SLOW_SPEED, UNSTABLE_SPEED } from 'src/Common/Constant'
import { SpeedHistory } from 'src/Common/SpeedHistory'

export enum Screen {
  Result,
  HistoryDetail,
  AdditionalDetails,
}

const useResultState = (props: RouteComponentProps, screen: Screen) => {
  const locationState: any = props.location.state
  const [resultState, setResultState] = useState(SpeedResultState.FAST)
  const [resultData] = useState<SpeedHistory>(locationState.result)

  useEffect(() => {
    if (resultData.download < UNSTABLE_SPEED) {
      setResultState(SpeedResultState.UNSTABLE)
    } else if (
      resultData.download >= UNSTABLE_SPEED &&
      resultData.download <= SLOW_SPEED
    ) {
      setResultState(SpeedResultState.SLOW)
    } else {
      setResultState(SpeedResultState.FAST)
    }
  }, [props.history.action, resultData, screen])

  return { resultState, resultData }
}

export default useResultState
